import { render, staticRenderFns } from "./WorkEnvSurveyDetails.vue?vue&type=template&id=52385be4"
import script from "./WorkEnvSurveyDetails.vue?vue&type=script&lang=js"
export * from "./WorkEnvSurveyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports